/**
 * AdminPortal job launcher (Admin API `api/admin-jobs`): the recompute / rebuild jobs that can be run on demand
 * from Statistics → Job history, and the popular-times jobs.
 */
import type { StatisticsJobDto } from './statistics'

export interface AdminJobDto {
  key: string
  name: string
  description: string
  jobType: string
  /** Every history job type this job re-runs (its own and e.g. the scheduled variant). */
  historyJobTypes: string[]
  /** Jobs sharing a lock group never run at the same time. */
  lockGroup: string
  /** Listed under "Run now" (false for jobs launched only from their own page). */
  showInRunNow: boolean
  acceptsParameters: boolean
  isRunning: boolean
  runningJobId?: string | null
  lastRun?: StatisticsJobDto | null
}

/** 202 body of every start endpoint. */
export interface StartedJobDto {
  jobId: string
  message?: string
}

/** `SystemActivityLog.Status`. */
export const JOB_STATUS = {
  Pending: 0,
  Running: 1,
  Cancelled: 2,
  Completed: 3,
  Failed: 4,
} as const
